import { ItemType } from "antd/lib/menu/hooks/useItems";
import { TypeMenu } from "../Models/Menu";

type Menu_ = TypeMenu & { foiLigadoAoPai?: boolean };

export const obterProfundidadeDasChaves = (items1: ItemType[] | undefined) => {
  const key: Record<string, number> = {};
  const func = (items2: any , level = 1) => {
    items2?.forEach((item: any) => {
      if (item.key) {
        key[item.key] = level;
      }

      if (item.children) {
        func(item.children, level + 1);
      }
    });
  }

  func(items1)
  return key;
}

const ordenar = (menu: Menu_[]): void => {
    menu.sort((a, b) =>
        a.prioridade > 0 || b.prioridade > 0
            ? -1 * (a.prioridade - b.prioridade)
            : (a.menusFilhos ?? []).length == 0 && (b.menusFilhos ?? []).length > 0
            ? -1
            : (a.menusFilhos ?? []).length > 0 && (b.menusFilhos ?? []).length == 0
            ? 1
            : a.nome.localeCompare(b.nome)
    );

    for (let m of menu) {
        if (m.menusFilhos && m.menusFilhos.length > 0) ordenar(m.menusFilhos);
    }
};

export const comporMenuHierarquico = (_menus: TypeMenu[]) => {
    const rec = (menu: Menu_, filhoAAdicionar: Menu_) => {
        if (menu.codigo === filhoAAdicionar.menuPai?.codigo) {
            if (menu.menusFilhos === undefined) menu.menusFilhos = [];

            menu.menusFilhos.push(filhoAAdicionar);
            filhoAAdicionar.foiLigadoAoPai = true;

            return;
        }

        menu.menusFilhos?.forEach((child) => {
            rec(child, filhoAAdicionar);

            if (filhoAAdicionar.foiLigadoAoPai === true) {
                return;
            }
        });
    };

    const menus: Menu_[] = [];

    let menusComRelacionamento = _menus
        .map((m) => ({ ...m, menusFilhos: [] }))
        .map((m) => (m.codPai != null ? { ...m, menuPai: _menus.find((n) => n.codigo == m.codPai) } : m));

    let queue: Menu_[] = menusComRelacionamento.filter((m) =>
        m.menuPai?.codigo == undefined ? true : !!menusComRelacionamento.find((n) => n.codigo == m.menuPai?.codigo)
    );

    for (; queue.length > 0; ) {
        let m = queue[0];
        queue = queue.slice(1);

        if (m.menuPai?.codigo === undefined) {
            menus.push(m);
            continue;
        }

        let deveContinuar = false;
        menus.forEach((M) => {
            rec(M, m);

            if (m.foiLigadoAoPai) {
                deveContinuar = true;
                return;
            }
        });

        if (deveContinuar) {
            continue;
        }

        queue.push(m);
    }

    ordenar(menus);

    return menus as TypeMenu[];
};

export function decomporMenu(menus: TypeMenu[]): TypeMenu[] {
    const resultado: TypeMenu[] = [];
    const visto = new Set<string>();

    function r(menuList: TypeMenu[]) {
        for (const menu of menuList) {
            if (!visto.has(menu.codigo)) {
                visto.add(menu.codigo);
                resultado.push(menu);
                if (menu.menusFilhos && menu.menusFilhos.length > 0) {
                    r(menu.menusFilhos);
                }
            }
        }
    }

    r(menus);
    return resultado;
}
